import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { VoipProvider, Phone } from 'monest-3cplus-socket';

/**
 * Constants import.
 */

const mapStateToProps = state => ({
    authUser: state.authentication.authUser,
    voipCampaign: state.operator.voipCampaign,
});

const VoipHoC = ({ children, authUser, voipCampaign }) => {
    const readOnly = window.sessionStorage.getItem('read-only');

    const voipToken = useMemo(() => {
        if (!authUser) {
            return undefined;
        }

        if (readOnly === 'true') {
            return undefined;
        }

        if (authUser.isOperator && authUser.voip_token) {
            return authUser.voip_token;
        }

        return undefined;
    }, [authUser]);

    return (
        <VoipProvider
            logWSEvents
            agentToken={voipToken}
            /* Hard coded receptive campaign. */
            auth={{ campaign: voipCampaign, mode: 'dialer' }}
        >
            {children}
            {voipToken
            && readOnly !== 'true'
            && <Phone />}
        </VoipProvider>
    );
}

export default connect(mapStateToProps)(VoipHoC);
